module.exports = __webpack_public_path__ + "static/media/cb-0.81d20e97.png";